/**
 * @generated SignedSource<<89dd7f37ebe1f7fd72e1d4864049bdbb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productSalesChannelListDeleteCodeMutation$variables = {
  code: string;
  modelID: string;
  salesChannelID: string;
};
export type productSalesChannelListDeleteCodeMutation$data = {
  readonly deleteModelCode: {
    readonly additionalCodes: ReadonlyArray<{
      readonly code: string;
      readonly salesChannelID: string;
    }>;
    readonly id: string;
    readonly modelID: number;
  } | null;
};
export type productSalesChannelListDeleteCodeMutation = {
  response: productSalesChannelListDeleteCodeMutation$data;
  variables: productSalesChannelListDeleteCodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "code"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "modelID"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "salesChannelID"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "code",
        "variableName": "code"
      },
      {
        "kind": "Variable",
        "name": "modelID",
        "variableName": "modelID"
      },
      {
        "kind": "Variable",
        "name": "salesChannelID",
        "variableName": "salesChannelID"
      }
    ],
    "concreteType": "Model",
    "kind": "LinkedField",
    "name": "deleteModelCode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "modelID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductCode",
        "kind": "LinkedField",
        "name": "additionalCodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "salesChannelID",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "productSalesChannelListDeleteCodeMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "productSalesChannelListDeleteCodeMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "56033dcf9d88982f5797a8a57c178a26",
    "id": null,
    "metadata": {},
    "name": "productSalesChannelListDeleteCodeMutation",
    "operationKind": "mutation",
    "text": "mutation productSalesChannelListDeleteCodeMutation(\n  $modelID: ID!\n  $code: String!\n  $salesChannelID: ID!\n) {\n  deleteModelCode(modelID: $modelID, code: $code, salesChannelID: $salesChannelID) {\n    id\n    modelID\n    additionalCodes {\n      code\n      salesChannelID\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "43b5104e12588e925e0b0894ae834d0a";

export default node;
